import { render } from "./ConfirmDelete.vue?vue&type=template&id=38a205f2&scoped=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"

import "./ConfirmDelete.vue?vue&type=style&index=0&id=38a205f2&lang=scss&scoped=true"

import exportComponent from "/Users/skynet/Documents/Sites Safe OK MAIS PEUT ETRE PAS A JOUR/Safe_Sites_Modifs/SAFE_BO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a205f2"]])

export default __exports__